<template>
    <v-app id="contai">
        <SideBare />
        <ToolBare>
            <template v-slot:cbody>
                <ProduitChips v-on:linkCliked="makeLinke()" />
            </template>
        </ToolBare>
        <component v-bind:is="cmp"></component>
    </v-app>
</template>
<script>
import SideBare from "../components/SideBare.vue";
import ToolBare from "@/components/ToolBare.vue";
import ProduitChips from "@/components/ProduitChips.vue";
import ListPieces from "../components/Pieces/ListPieces.vue";
import ListFournisseurView from "@/components/Fournisseurs/ListFournisseurView.vue"
export default {
    name: "PiecesView",
    data: () => ({
        cmp: '',
    }),
    components: {
        SideBare,
        ToolBare,
        ProduitChips,
        "articles":ListPieces,
        "fournisseur":ListFournisseurView,
    },
    methods: {
       makeLinke() {
            this.cmp = window.location.pathname.split('/').pop()
        },
    },
    created(){
        this.makeLinke()
    }
}
</script>
<style>
</style>